export default __webpack_public_path__ + "static/Metal_Pillar-55a1eb9c72bec89c763c3469f831653e.png";